import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser';
import { CardComponent } from '../card.component';
import { Router } from '@angular/router';
// import { Blog, BlogList, BlogService } from '../../../../generated';

@Component({
  selector: 'app-buzz-card',
  templateUrl: './buzz.component.html',
  styleUrls: ['./buzz.component.scss']
})
export class BuzzCardComponent extends CardComponent implements OnInit {

  // blogData: Blog;

  @Input() classes = 'background-dark general-dark2-bg';
  @Input() topLeftTextClasses = 'general-white';
  @Input() topRightTextClasses = 'gray2';
  @Input() titleClasses = 'text-white h4-nc';
  @Input() descriptionClasses = 'gray2';
  @Input() linkClasses = 'cream-link';
  @Input() linkText = 'Read Article <i class=\'fas fa-arrow-right\'></i>';
  @Input() bottomRight = '<i class=\'fas fa-newspaper\'></i>';
  @Input() bottomRightTextClasses = 'gray2-md';


  // CMS service
  // private readonly BlogService: BlogService

  constructor(
      sanitize: DomSanitizer,
      router: Router) {
    super(sanitize, router);
  }

  ngOnInit() {
    // this.fetchData();
  }

  // CMS function
  // async fetchData () {
  //   const blogList: BlogList = await this.BlogService.getOrgsOrgnameBlog('global', true).toPromise();
  //   if (!!blogList && !!blogList[0]) {
  //     this.blogData = blogList[0];
  //   }
  // //console.log('init(): homepage data', this.blogData);
  // }

}
